import {useTranslation} from "react-i18next";
import {Consts} from "../pages/consts";
import React, {useContext, useEffect, useState} from "react";
import useMmcService from "../../services/MmcService";
import InitContext from "../pages/InitContext";
import PatientGenes from "../pgx/PatientGenes";
import ErrorMessage from "../errorMessage/ErrorMessage";
import Spinner from "../spinner/Spinner";
import CreateNewGeneView from "../pgx/CreateNewGeneView";
import NewPgxTest from "../pgx/NewPgxTest";
import {getPatientName} from "../pages/utils";

const PatientPGx = ({
                      patient,
                      updatePatient,
                      showDialog,
                      onCloseDialog,
                    }) => {
  const {t} = useTranslation();
  const [newPgx, setNewPgx] = useState(null);
  const [patGenes, setPatGenes] = useState([]);
  const [createNewDialogOpened, setCreateNewDialogOpened] = useState(false);
  const [newGenesSelected, setNewGenesSelected] = useState(false);
  const [availableGeneNames, setAvailableGeneNames] = useState([]);
  const context = useContext(InitContext);
  const {clearError, error, loading, saveDbGeneTest, getDbGenes} = useMmcService();

  useEffect(() => {
    if (patGenes === undefined || patGenes === null || patGenes?.length === 0) {
      fetchDbGenes().then();
    }
  }, [patient?.id]);

  const fetchDbGenes = async () => {
    clearError();

    try {
      const genesInDb = await getDbGenes(context?.token, patient?.id);

      if(genesInDb){
        setPatGenes(genesInDb);
      }

      if (!availableGeneNames?.length) {
        setAvailableGeneNames(Consts.ALL_GENE_NAMES);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleSaveNewGeneTest = async () => {
    clearError();

    saveDbGeneTest(context?.token, newPgx, patient?.id).then(() => {
      clearError();

      getDbGenes(context?.token, patient?.id).then((genesInDb) => {
        setPatGenes(genesInDb);
        setNewPgx(null);
        setCreateNewDialogOpened(false);
        setNewGenesSelected(false);
        setAvailableGeneNames(Consts.ALL_GENE_NAMES);
        updatePatient(genesInDb);
      });
    });
  };

  const handleSetPatGenes = (newGenes) => {
    setPatGenes(newGenes)
  }

  const handleInitNewTest = (newGenes) => {
    setNewPgx((prev) => ({...prev, genes: newGenes}));
  }

  const showGenesAfterStoringNewTest = (newGenes) => {
    setNewGenesSelected(false);
    setCreateNewDialogOpened(false)
    setNewPgx((prev) => ({...prev, genes: newGenes}));
    setPatGenes(newGenes);
  }

  const handleCreateNewTest = () => {
    setNewPgx(null);
    setCreateNewDialogOpened(true);
    setNewGenesSelected(false);
    setAvailableGeneNames(Consts.ALL_GENE_NAMES);
  }

  const handleCancel = () => {
    fetchDbGenes().then(() => {
      setNewPgx(null);
      setCreateNewDialogOpened(false);
      setNewGenesSelected(false);
      setAvailableGeneNames(Consts.ALL_GENE_NAMES);
    });
  }

  const errorMessage = error && <ErrorMessage message={ t(error?.includes(Consts.POST)
    ? "error_by_saving_pgx_test_data"
    : "error_by_getting_pgx_test_data") }/>;

  const spinner = loading && <Spinner/>;
  const isStudyDirector = context?.role === Consts.STUDY_DIRECTOR;
  console.log("role", context?.role);

  return (
    <div className="w3-modal" style={ {display: showDialog ? Consts.BLOCK : Consts.NONE} }>
      <div className="w3-modal-content w3-card-4 w3-animate-zoom w3-theme-l3 dialog-wide">
        <div className="w3-row w3-margin">
          <header className="w3-col s8 w3-container w3-center">
            <h2>
              { t("pharmacogenetic_test_results") }
              { context?.role !== Consts.PATIENT && `: ${getPatientName(patient, isStudyDirector)}` }
            </h2>
          </header>
          { (!createNewDialogOpened && !newGenesSelected && context?.role === Consts.HCP_PRESCRIBER) &&
            <button className="w3-col s3 w3-btn w3-round-xlarge w3-theme-d5 w3-margin-top"
                    onClick={ handleCreateNewTest }>
              { t("create_new") }
            </button>
          }
        </div>
        { errorMessage }
        { spinner }
        <div className="w3-container" id="pgx-parent">
          { createNewDialogOpened &&
            <CreateNewGeneView newPgx={ newPgx } setNewPgx={ setNewPgx } availableGeneNames={ availableGeneNames }
                               setAvailableGeneNames={ setAvailableGeneNames } onHandleInitNewTest={ handleInitNewTest }
                               onHandleNextClick={ () => setCreateNewDialogOpened(false) }
                               onHandleCancel={ handleCancel }/>
          }
          { !createNewDialogOpened && newPgx !== null && // shows a view with rows of a new PGx (not yet saved, no ID)
            <>
              <NewPgxTest newPgx={ newPgx } setNewPgx={ setNewPgx } handleSetPatGenes={ showGenesAfterStoringNewTest }
                          patientId={  patient?.id } handleSaveNewGeneTest={ handleSaveNewGeneTest }
                          handleCancel={ handleCancel }/>
            </>
          }
          { !createNewDialogOpened && newPgx === null && // shows PGx with trash icons (saved, with ID)
            <div className="w3-container">
              <PatientGenes patGenes={ patGenes } setPatGenes={ handleSetPatGenes } patientId={ patient?.id } />
            </div>
          }
          <footer className="w3-container w3-center w3-padding-small">
            <p className="w3-right">
              <button className="w3-btn w3-round-xlarge w3-theme-d5 w3-margin-left" onClick={ onCloseDialog }>
                { t("close") }
              </button>
            </p>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default PatientPGx;
